import React from "react";
import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import MyNavLink from "@/components/MyNavLink";
import style from "./style.less";
import { LanguageContext } from "@/data/LanguageProvider";

const Promotion = () => {
  const { langText } = React.useContext(LanguageContext)
  return (
    <div class={style.page_container}>
      <HomeHeaderOther title={langText("home_btn_promotion")} />
      <div class={style.promotion}>
        <MyNavLink to="/invite" style={{ color: "#ffffff" }}>
          <div class={style.pro_ele}>
            <div class={style.pro_img}>
              <img src={require("@/assets/images/home/huodongtu1.jpg").default} />
            </div>
            <div class={style.pro_info}>
              <div class={style.pro_time}>03/12/2019 - 01/08/2031</div>
              <div class={style.pro_more}>Learn more</div>
            </div>
          </div>
        </MyNavLink>
        <MyNavLink to="/deposit" style={{ color: "#ffffff" }}>
          <div class={style.pro_ele}>
            <div class={style.pro_img}>
              <img src={require("@/assets/images/home/promotion_tu2.jpg").default} />
            </div>

            <div class={style.pro_info}>
              <div class={style.pro_time}>03/12/2019 - 01/08/2031</div>
              <div class={style.pro_more}>Learn more</div>
            </div>
          </div>
        </MyNavLink>
      </div>
    </div>
  );
};

export default Promotion;
